import { ILayoutData, TPageTable } from '../../interfaces';
import React from 'react';

import { SanityPage } from '../../../graphql-types';

import Layout from '../../components/shared/layout';
import * as sanity from '../../sanity-image';

import { ContentBlocks } from '../../components/tailwind/content-blocks';

import SEO from '../../components/seo';

import { getMetadataFromPageTable } from '../../helpers/get-metadata';
import { Container } from '../../components/tailwind/atoms/container';
import { Breadcrumbs } from '../../components/tailwind/molecules/breadcrumbs';

type PageProps = {
    pageContext: {
        layoutData: ILayoutData;

        page: SanityPage;
        pageTable: TPageTable;
    };
};

export const Page = ({ pageContext }: PageProps) => {
    const { layoutData, page, pageTable } = pageContext;

    if (!page) {
        return null;
    }

    const { blocks, seo } = page;

    const { language } = layoutData;

    const ogImageString = seo?.image ? sanity.urlFor(seo.image).width(1200).height(630).url() : '';
    const twitterImageString = seo?.image
        ? sanity.urlFor(seo.image).width(450).height(450).url()
        : '';

    const metadata = getMetadataFromPageTable({
        pageTable: pageTable,
        language: language,
        withDefaultTag: true,
    });

    const categoryPage = page.categoryPage;

    return (
        <>
            <SEO
                title={seo?.title || page.title}
                lang={language}
                description={seo?.description}
                ogImage={ogImageString}
                alternates={metadata?.alternates}
                canonicalURL={metadata?.canonicalUrl}
                twitterImage={twitterImageString}
            />
            <Layout pageTable={pageTable} layoutData={layoutData}>
                <Container>
                    <Breadcrumbs
                        className="my-4 md:my-6"
                        language={language}
                        links={[
                            ...(categoryPage
                                ? [
                                      {
                                          url: `/${language}/${categoryPage?.slug?.current}` || '',
                                          title: categoryPage?.title || '',
                                      },
                                  ]
                                : []),
                            {
                                url: pageTable[language],
                                title: page.title || seo?.title || '',
                            },
                        ]}
                    />
                </Container>
                {blocks ? <ContentBlocks blocks={blocks} /> : null}
            </Layout>
        </>
    );
};

export default Page;
